      <div class="studio-split"{{{ root }}}>
        <figure class="studio-figure reveal">
          {{{ img }}}
{{#if caption}}
          <figcaption{{{ caption.attrs }}}>{{{ caption.html }}}</figcaption>
{{/if}}
        </figure>

        <div class="studio-body">
{{{ body }}}
        </div>
      </div>
